
import { useI18n } from "vue-i18n";
import { defineComponent, defineAsyncComponent } from "vue";
import locales from "@/utils/Locales";

export default defineComponent({
  name: "Privacy",
  setup() {
    const { t } = useI18n({ useScope: "global" });

    const cookieLocale = locales.initLocale();
    console.log(cookieLocale, "cookieLocale");

    const privacyPolicyContent = locales.isKorean(cookieLocale)
      ? defineAsyncComponent(() => import("./privacies/ko.vue"))
      : locales.isUzbek(cookieLocale)
      ? defineAsyncComponent(() => import("./privacies/uz.vue"))
      : locales.isRussian(cookieLocale)
      ? defineAsyncComponent(() => import("./privacies/ru.vue"))
      : defineAsyncComponent(() => import("./privacies/en.vue"));

    return { t, privacyPolicyContent };
  },
});
